import { render, staticRenderFns } from "./BulkNotificationV2.vue?vue&type=template&id=3e2412c4&scoped=true&"
import script from "./BulkNotificationV2.vue?vue&type=script&lang=js&"
export * from "./BulkNotificationV2.vue?vue&type=script&lang=js&"
import style0 from "./BulkNotificationV2.vue?vue&type=style&index=0&id=3e2412c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2412c4",
  null
  
)

export default component.exports